const socialUrls = [
  {
    type: 'linkedin',
    urlPrefix: 'https://www.linkedin.com/company/',
    title: 'LinkedIn',
    width: 16
  },
  {
    type: 'twitter',
    urlPrefix: 'https://twitter.com/',
    title: 'Twitter',
    width: 16
  },
  {
    type: 'facebook',
    urlPrefix: 'https://www.facebook.com/',
    title: 'Facebook',
    width: 18
  },
  {
    type: 'instagram',
    urlPrefix: 'https://www.instagram.com/',
    title: 'Instagram',
    width: 22
  },
  {
    type: 'youtube',
    urlPrefix: 'https://www.youtube.com/channel/',
    title: 'YouTube',
    width: 18
  },
  {
    type: 'medium',
    urlPrefix: 'https://medium.com/',
    title: 'Medium',
    width: 18
  }
]

const formatLink = (type, socialIdOnInstance) => {
  const data = socialUrls.find((t) => t.type === type)
  return {
    ...data,
    icon: data.type,
    url: `${data.urlPrefix}${socialIdOnInstance}`
  }
}

const formatSocialLinks = (instance) => {
  const socialTypes = [
    'linkedin',
    'twitter',
    'facebook',
    'instagram',
    'youtube',
    'medium'
  ]
  const enabledSocialLinks = []
  socialTypes.forEach((t) => {
    const socialIdOnInstance = instance[`${t}Id`]
    if (socialIdOnInstance) {
      enabledSocialLinks.push(formatLink(t, socialIdOnInstance))
    }
  })
  return enabledSocialLinks
}

export default formatSocialLinks
